export function getStartListUrl(masterId, eventId, courseId) {
  if(!eventId) {
    return `/event/${masterId}/startList`;
  }
  const base = `/event/${masterId}/startList/Event/${eventId}`;
  return courseId ? `${base}/Course/${courseId}` : base;
}


/** WEBPACK FOOTER **
 ** ./utils/startListHelpers.js
 **/